import * as React from "react";
import { forwardRef } from "react";
const SvgSort = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 18.815 5.185 12l.928-.92 5.237 5.237V5.185h1.3v11.132l5.236-5.236.93.919L12 18.815Z" }));
const ForwardRef = forwardRef(SvgSort);
export { ForwardRef as ReactComponent };
